import { trackEvent } from '../lib/analytics';

// The register gate (anonymous -> Free): an invitation, not a paywall.
// Deliberately no lock icon and no pricing language anywhere in this
// component — requirements §5 calls this out as the single most common way
// this kind of page fails (a register wall that LOOKS like a pay wall makes
// people bounce before they ever see the free tier).
export function RegisterGate({ message }: { message?: string }) {
  return (
    <div className="tr-gate">
      <h2>Create a free account to continue</h2>
      <p>
        {message ?? 'Module 1 is free, complete, and yours the moment you sign up — no card required.'}
      </p>
      <button
        className="tr-btn tr-btn-primary"
        onClick={() => trackEvent('training_tab_opened', { from: 'register_gate' })}
      >
        Create a free account
      </button>
    </div>
  );
}
